import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b979975c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-meus-atalhos" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "ss-meus-atalhos-titulo"
}
const _hoisted_5 = { class: "ss-meus-atalhos-titulo-categoria" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remover atalho", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  style: {"color":"#2c3e50"},
  class: "anticon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.storeSistema.getters.atalhosEmpresaEmOperacao().length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_a_empty, { description: 'Nenhum atalho foi adicionado ainda.' }, null, 8, ["description"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_ctx.storeSistema.state.layoutMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Meus Atalhos"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeSistema.getters.atalhosEmpresaEmOperacao(), (menu) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: menu.categoria
              }, [
                _createElementVNode("h4", _hoisted_5, _toDisplayString(menu.categoria), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.atalhos, (atalho) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "ss-meus-atalhos-item",
                    key: atalho.codigo
                  }, [
                    _createVNode(_component_router_link, {
                      to: { path: `/${atalho.rotaRecurso}` }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(atalho.titulo), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createVNode(_component_a_tooltip, { placement: "bottom" }, {
                      title: _withCtx(() => [
                        _hoisted_6
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          style: {"float":"right"},
                          onClick: ($event: any) => (_ctx.removerAtalhoEmpresaOperacao(atalho.identificadorRecurso))
                        }, [
                          _createElementVNode("i", _hoisted_8, [
                            _createVNode(_component_icone, { nome: "favorito" })
                          ])
                        ], 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
    ])
  ]))
}